import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  listContainer: {
    overflow: 'auto',
    border: '1px solid rgb(221, 221, 221)',
    height: 'calc(80vh - 216px)',
    borderRadius: 4,

    [theme.breakpoints.down('xs')]: {
      height: 'calc(95vh - 280px)',
    },
  },
  listItem: {
    paddingLeft: 4,
    cursor: 'pointer',
  },
  message: {
    padding: theme.spacing(2),
    textAlign: 'center',
  },
}));
